export default "__VITE_ASSET__CTW7qBa8__"